<template>
	<b-modal id="entities_form_modal" ref="bvModal" :no-close-on-backdrop="true">
		<template v-slot:modal-header="{ close }">
			<div class="modal-header-buttons-container">
				<h2>{{ modalTitle }}</h2>
			</div>
		</template>
		<div class="modal-fields">
			<div class="modal-body-section">
				<div class="modal-inputs-holder">
					<div class="form-groups-container">
						<div class="bb-form-group">
							<label>{{
                $t("physicalEntityFormModal.firstNameInput.label")
              }}</label>
							<input class="bb-input" type="text" v-model="form.fields.firstName" />
							<div class="bb-invalid-feedback" v-show="form.errors.firstName">
								{{ $t("physicalEntityFormModal.validation.error") }}
							</div>
						</div>
						<div class="bb-form-group">
							<label>{{
                $t("physicalEntityFormModal.lastNameInput.label")
              }}</label>
							<input class="bb-input" type="text" v-model="form.fields.lastName" />
							<div class="bb-invalid-feedback" v-show="form.errors.lastName">
								{{ $t("physicalEntityFormModal.validation.error") }}
							</div>
						</div>
					</div>
					<div class="bb-form-group">
						<label>{{ $t("physicalEntityFormModal.emailInput.label") }}</label>
						<input class="bb-input" type="email" v-model="form.fields.email" />
						<div class="bb-invalid-feedback" v-show="form.errors.email">
							{{ $t("physicalEntityFormModal.validation.error") }}
						</div>
					</div>
					<div class="form-groups-container">
						<div class="bb-form-group">
							<label>{{
                $t("physicalEntityFormModal.phoneInput.label")
              }}</label>
							<input class="bb-input" type="text" v-model="form.fields.phone" />
							<div class="bb-invalid-feedback" v-show="form.errors.phone">
								{{ $t("physicalEntityFormModal.validation.error") }}
							</div>
						</div>
						<div class="bb-form-group">
							<label>{{
                $t("physicalEntityFormModal.personalIdentityNumber.label")
              }}</label>
							<input class="bb-input" type="text" v-model="form.fields.personalIdentityNumber" />
							<div class="bb-invalid-feedback" v-show="form.errors.personalIdentityNumber">
								{{ $t("physicalEntityFormModal.validation.error") }}
							</div>
						</div>
					</div>
					<div class="bb-form-group">
						<label>{{
              $t("physicalEntityFormModal.sendNotificationsByInput.label")
            }}</label>
						<BBSelect :options="sendNotificationsOptions" v-model="form.helpers.notificationsSentBy"></BBSelect>
						<div class="bb-invalid-feedback" v-show="form.errors.notificationsSentBy">
							{{ $t("physicalEntityFormModal.validation.error") }}
						</div>
					</div>
					<div class="bb-form-group">
						<BBCheckbox v-model="form.fields.marketingNotificationsEnabled" :label="
                $t('physicalEntityFormModal.notificationsEnabledInput.label')
              " />
						<div class="bb-invalid-feedback" v-show="form.errors.marketingNotificationsEnabled">
							{{ $t("physicalEntityFormModal.validation.error") }}
						</div>
					</div>
				</div>
			</div>
			<div class="modal-body-section">
				<div class="modal-inputs-holder">
					<div class="">
						<div class="bb-form-group">
							<label>{{
                $t("physicalEntityFormModal.addressInput.label")
              }}</label>
							<input type="text" class="bb-input" v-model="form.fields.address" />
							<div class="bb-invalid-feedback" v-show="form.errors.address">
								{{ $t("physicalEntityFormModal.validation.error") }}
							</div>
						</div>
						<div class="form-groups-container">
							<div class="bb-form-group">
								<label>{{
                  $t("physicalEntityFormModal.cityInput.label")
                }}</label>
								<input class="bb-input" type="text" v-model="form.fields.city" />
								<div class="bb-invalid-feedback" v-show="form.errors.city">
									{{ $t("physicalEntityFormModal.validation.error") }}
								</div>
							</div>
							<div class="bb-form-group">
								<label>{{
                  $t("physicalEntityFormModal.zipCodeInput.label")
                }}</label>
								<input type="text" class="bb-input" v-model="form.fields.zipCode" />
								<div class="bb-invalid-feedback" v-show="form.errors.zipCode">
									{{ $t("physicalEntityFormModal.validation.error") }}
								</div>
							</div>
						</div>
						<div class="bb-form-group">
							<label>{{
                $t("physicalEntityFormModal.notesInput.label")
              }}</label>
							<b-form-textarea rows="3" class="bb-textarea" v-model="form.fields.note"></b-form-textarea>
							<div class="bb-invalid-feedback" v-show="form.errors.note">
								{{ $t("physicalEntityFormModal.validation.error") }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<template v-slot:modal-footer="{ close }">
			<div class="footer-right">
				<button id="close_entities_form_modal" class="bb-btn btn-outline" @click="close()">
					{{ $t("physicalEntityFormModal.closeBtn") }}
				</button>
				<button class="bb-btn btn-success" @click="submit()">
					{{ $t("physicalEntityFormModal.saveBtn") }}
				</button>
			</div>
		</template>
	</b-modal>
</template>

<script>
import physicalEntityForm from '@/core/services/forms/physicalEntityForm.js';
import formMixin from '@/core/mixins/formMixin.js';
import BBSelect from '@/view/content/BBForm/BBSelect.vue';
import BBCheckbox from '@/view/content/BBForm/BBCheckbox.vue';
import i18nService from '@/core/services/i18n.service.js';
import moment from 'moment';
import { SET_ALERT_MESSAGES } from '@/core/services/store/alert.module.js';
import { GET_PHYSICAL_ENTITIES } from '@/core/services/store/physical_entities.module';

export default {
	name: 'ClientFormModal',
	props: {
		perPage: {
			type: Number,
		},
		pageNumber: {
			type: Number,
		},
	},
	mixins: [formMixin],
	components: {
		BBSelect,
		BBCheckbox,
	},
	emits: ['entityCreated', 'entityUpdated'],
	data() {
		return {
			sendNotificationsOptions: [
				{
					text: this.$t('physicalEntityFormModal.sendNotificationsByInput.options.email'),
					value: 'email',
				},
				{
					text: this.$t('physicalEntityFormModal.sendNotificationsByInput.options.dontSend'),
					value: 'dont_send',
				},
			],
		};
	},
	beforeMount() {
		// Get form object from clientForm service
		this.form = JSON.parse(JSON.stringify(physicalEntityForm));
		// Set moment locale
		moment.locale(i18nService.getActiveLanguage());
	},
	methods: {
		/**
		 * Show the modal
		 * @return {void}
		 */
		show() {
			this.$refs.bvModal.show();
		},
		/**
		 * Close the modal
		 * @return {void}
		 */
		closeModal() {
			document.querySelector('#close_entities_form_modal').click();
		},

		/**
		 * Update form fields from form helpers
		 * @return {void}
		 */
		updateFormFields() {
			this.form.helpers.notificationsSentBy == 'email'
				? (this.form.fields.bookingNotificationsEnabled = true)
				: (this.form.fields.bookingNotificationsEnabled = false);

			if (this.form.mode == 'edit') {
				this.form.path = this.form.path + '/' + this.form.fields.id;
			}
		},

		/**
		 * Submit the form
		 * @return {void}
		 */
		submit() {
			this.updateFormFields();
			this.submitForm()
				.then((response) => {
					this.$store.dispatch(SET_ALERT_MESSAGES, {
						successMessages: [response.data.message],
						errorMessages: null,
					});
					if (this.form.mode == 'edit' && this.$route.name == 'clients') {
						this.closeModal();
						this.$store.dispatch(GET_PHYSICAL_ENTITIES, {
							perPage: this.perPage,
							pageNumber: this.pageNumber,
						});
					} else if (this.form.mode == 'edit' && this.$route.name != 'clients') {
						this.closeModal();
						this.$emit('entityUpdated');
					} else {
						this.closeModal();
						this.$emit('entityCreated');
						this.$store.dispatch(GET_PHYSICAL_ENTITIES, {
							perPage: this.perPage,
							pageNumber: this.pageNumber,
						});
					}
				})
				.catch((error) =>
					this.$store.dispatch(SET_ALERT_MESSAGES, {
						successMessages: null,
						errorMessages: [error.response.data.message],
					})
				);
		},
	},
	computed: {
		/**
		 * Return modal title
		 * @return {String}
		 */
		modalTitle() {
			return this.form.mode === 'edit' ? this.$t('physicalEntityFormModal.editTitle') : this.$t('physicalEntityFormModal.createTitle');
		},

		/**
		 * Determine if left footer section is visible
		 * @return {Boolean}
		 */
		footerLeftVisible() {
			if (window.innerWidth < 992) {
				return this.form.mode === 'edit';
			}
			return true;
		},
	},
};
</script>

<style lang="scss">
@import '@/assets/sass/bb-styles/modals/entities-form-modal.scss';
</style>
